import React, { useContext } from 'react';
import Checkbox from '@material-ui/core/Checkbox';
import TableCell from '@material-ui/core/TableCell';
import cx from 'classnames';
import makeStyles from '@material-ui/core/styles/makeStyles';
import TableContext from '../TableContext';
import { rowHeight } from '../constants';

const useStyles = makeStyles(theme => ({
  flexContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  tableRow: {
    cursor: 'pointer'
  },
  tableRowHover: {
    '&:hover': {
      backgroundColor: theme.palette.grey[200]
    }
  },
  tableCell: {
    flex: 1,
    border: 0
  },
  noClick: {
    cursor: 'initial'
  }
}));

const SelectionCell = ({ rowData }) => {
  const classes = useStyles();
  const { isRowSelected, toggleSelectObject } = useContext(TableContext);
  const isSelected = isRowSelected(rowData.id);
  return (
    <TableCell
      component="div"
      className={cx(classes.tableCell, classes.flexContainer)}
      variant="body"
      style={{ height: rowHeight }}
      onClick={event => {
        event.stopPropagation();
      }}
      padding="checkbox"
    >
      <Checkbox
        checked={isSelected}
        onClick={() => toggleSelectObject(rowData.id)}
        inputProps={{ 'data-testid': 'table-body-select-checkbox' }}
      />
    </TableCell>
  );
};

const selectionCellRender = ({ rowData }) => {
  return <SelectionCell rowData={rowData} />;
};

export default SelectionCell;
export { selectionCellRender };
